import { Injectable } from '@angular/core';
import { NearbyEventNew, EventProvider, EventListModel, EventDetailsModel } from '../../../providers/event/event';
import { ConfigProvider } from '../../../providers/config/config';

@Injectable()
export class NearbyMainResolver {
  constructor(private eventService: EventProvider, private config: ConfigProvider) { }

  resolve(route: any, state: any): Promise<any> {
    // / TODO IMPLEMENT
    return this.doResolve(route, null);
  }

  doResolve(events: EventDetailsModel[], config = null): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      let ids = [];
      events.forEach(eventitem => ids.push(eventitem.id + ''));
      console.log('r-1');
      let filteredEvents = events;
      console.log('r-2');

      this.eventService.getNearbyEvents(ids).then(data => {
        console.log('r-3');
        if (config.nearby && config.nearby.fakeStart) {
          let fake = config.nearby.fakeStart;
          data.forEach((item, index) => {
            item.date = fake[index] ? new Date().getTime() + fake[index] * 1000 : item.date;
          });
        }
        console.log('r-4');
        data.forEach(citem => {
          citem.event = filteredEvents.find(x => x.id === citem.id);
          citem.participants = [];
          citem.mode = null;
        });
        console.log('r-5');
        if (config.nearby && config.nearby.fakeTimes) {
          let times = config.nearby.fakeTimes;
          data.forEach((item, index) => {
            item.timeInfos = times[index] || [];
          });
        }
        console.log('r-6');
        resolve({
          nearbyEvents: data,
          mapState: null,
          selectedIndex: 0,
          trackLocation: false
        });
      });
    });
  }
}

export interface NearbyMainViewModel {
  mapState?: MapStateOptions;
  nearbyEvents: NearbyEventNew[];
  selectedIndex: number;
  trackLocation: boolean;
}

export interface MapStateOptions {
  zoom?: number;
  center?: { lat: number; lng: number };
}



// WEBPACK FOOTER //
// /src/pages/nearby/main/nearby-main-resolver.ts